import * as Yup from 'yup';
import planesFormModel from './planesFormModel';

const {
  formField: {
    name,
    description,
    monthlyPrice,
    currency,
    monthlyCredits,
    durationDays,
    maxRequestsDay,
    maxRequestsMonth,
    maxAssistants,
    maxAgents,
    maxUsers,
    allowChat,
    allowImages,
    allowAudio,
    allowDocuments,
    allowEmbeddings,
    allowMemory,
    allowTools,
    allowRag,
    sortOrder,
  },
} = planesFormModel;

export default Yup.object().shape({
  [name.name]: Yup.string().required(name.requiredErrorMsg).max(255),
  [description.name]: Yup.string().required(description.requiredErrorMsg),
  [monthlyPrice.name]: Yup.number().min(0).required(monthlyPrice.requiredErrorMsg),
  [currency.name]: Yup.object()
    .shape({
      value: Yup.string().required(),
      label: Yup.string().required(),
    })
    .required(currency.requiredErrorMsg),
  [monthlyCredits.name]: Yup.number().min(0).required(monthlyCredits.requiredErrorMsg),
  [durationDays.name]: Yup.number().min(0).required(durationDays.requiredErrorMsg),
  [maxRequestsDay.name]: Yup.number().min(0).required(maxRequestsDay.requiredErrorMsg),
  [maxRequestsMonth.name]: Yup.number().min(0).required(maxRequestsMonth.requiredErrorMsg),
  [maxAssistants.name]: Yup.number().min(0).required(maxAssistants.requiredErrorMsg),
  [maxAgents.name]: Yup.number().min(0).required(maxAgents.requiredErrorMsg),
  [maxUsers.name]: Yup.number().min(0).required(maxUsers.requiredErrorMsg),
  [allowChat.name]: Yup.boolean().optional(),
  [allowImages.name]: Yup.boolean().optional(),
  [allowAudio.name]: Yup.boolean().optional(),
  [allowDocuments.name]: Yup.boolean().optional(),
  [allowEmbeddings.name]: Yup.boolean().optional(),
  [allowMemory.name]: Yup.boolean().optional(),
  [allowTools.name]: Yup.boolean().optional(),
  [allowRag.name]: Yup.boolean().optional(),
  [sortOrder.name]: Yup.number().required(sortOrder.requiredErrorMsg),
});
